import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReporteModalComponent } from './reporte-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [ReporteModalComponent],
  imports: [
    CommonModule, SharedModule, ReactiveFormsModule
  ]
})
export class ReporteModalModule { }
